import { render, staticRenderFns } from "./SetYellow.vue?vue&type=template&id=5324d95e&scoped=true&"
import script from "./SetYellow.vue?vue&type=script&lang=js&"
export * from "./SetYellow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324d95e",
  null
  
)

export default component.exports